import { render, staticRenderFns } from "./ProjectArticle.vue?vue&type=template&id=6894b816&scoped=true&"
import script from "./ProjectArticle.vue?vue&type=script&lang=js&"
export * from "./ProjectArticle.vue?vue&type=script&lang=js&"
import style0 from "./ProjectArticle.vue?vue&type=style&index=0&id=6894b816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6894b816",
  null
  
)

export default component.exports